import { groupNode, inlineNode, matrixNode, operatorNode } from "../utils";

import type { SympyResult } from "../types";
import type { SympyParser } from "./SympyParser";

export function parsePower(parser: SympyParser, baseArgs: SympyResult, exponentArgs: SympyResult) {
  let base = parser.parseResult(baseArgs);
  // Exponents keep their fraction/root form (x^(3/2) stays a fraction, not x^1.5).
  const exponent = parser.parseResult(exponentArgs, { exponent: true });

  if (base.length > 0 && exponent.length > 0) {
    // If base has more than one element, wrap it in parentheses
    if (base.length > 1) {
      base = [groupNode("(", ")", [matrixNode(1, 1, [inlineNode(...base)])])];
    }

    if (base.length === 1 && base[0].type === "function") {
      // If base is a function, attach the exponent to the function
      // Ex: sin(x)^2 becomes sin^2(x)
      return [
        {
          ...base[0],
          children: [operatorNode("power", [inlineNode(...exponent)]), ...base[0].children],
        },
      ];
    }

    return [...base, operatorNode("power", [inlineNode(...exponent)])];
  }

  return base;
}
